import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { AppUiProvider } from './context/AppUiContext';
import './index.scss';
import App from './App';
import { AuthProvider } from './auth/AuthContext';
import { QueryProvider } from './query/QueryProvider';
import theme from './theme';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <QueryProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <AppUiProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </AppUiProvider>
        </BrowserRouter>
      </ThemeProvider>
    </QueryProvider>
  </React.StrictMode>,
);

reportWebVitals();
